<template>
    <myPage :max_flag="true">
        <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
            <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
            </el-button-group>
            <div class="f-bd f14 text-nowrap">移动时间{{$t('x_mh')}}</div>
            <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
            <div class="mg-right5 mg-top5" v-if="org_id == ''">
                <el-input size="small" v-model="search.org_cname">
                    <span slot="prepend">客户名称{{$t('x_dd')}}</span>
                </el-input>
            </div>
            <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
        </div>
        <div class="fillw fillh">
            <el-table :data="listData" class="fillw show-scroll" height="100%">
                <el-table-column fixed :label="listHeader.org_cname" width="180px">
                    <el-table-column label-class-name="f-red pd-top0" width="180px">
                        <template slot-scope="scope" slot="header">合计</template>
                        <div slot-scope="scope">{{scope.row.org_cname}}</div>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="add_time" :label="listHeader.add_time" width="160px"> </el-table-column>
                <el-table-column width="150px" prop="cr_cat_cdesc">
                    <template slot-scope="scope" slot="header">
                        <myDropdown :title="listHeader.cr_cat_cdesc" :list="cr_cat" v-model="search.cr_cat"
                                    title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                    </template>
                </el-table-column>
                <el-table-column width="120px" prop="sn_type_cdesc">
                    <template slot-scope="scope" slot="header">
                        <myDropdown :title="listHeader.sn_type_cdesc" :list="sn_type" v-model="search.sn_type"
                                    title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                    </template>
                </el-table-column>
                <el-table-column :label="listHeader.mv_cr_qty">
                    <el-table-column label-class-name="f-red pd-top0" width="120px">
                        <template slot-scope="scope" slot="header">{{totalData.sum.mv_cr_qty * 1}}</template>
                        <div class="f-red f-bd" slot-scope="scope"><span v-if="scope.row.mv_cr_qty * 1 > 0">+</span>{{scope.row.mv_cr_qty * 1}}</div>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="listHeader.new_cr_qty" width="120px">
                    <template slot-scope="scope">{{scope.row.new_cr_qty * 1}}</template>
                </el-table-column>
                <el-table-column prop="order_code" :label="listHeader.order_code" min-width="180px"> </el-table-column>
            </el-table>
        </div>
        <div slot="footer">
            <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                     v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
        </div>
    </myPage>
</template>

<script>
    import myDatePicker from "./myDatePicker";
    import myPager from "./myPager";
    import myDropdown from "./myDropdown";
    import excel from '../utils/excel'
    export default {
        name: "myOrgCrSn",
        components:{
            myDatePicker,
            myPager,
            myDropdown
        },
        props: {
            org_id: {
                default: '',
                type: String,
            },
            url: {
                default: '',
                type: String,
            }
        },
        data:function(){
            const listHeader = {
                org_cname: '客户名称',
                add_time: '移动时间(实时)',
                cr_cat_cdesc: '信誉消费模式',
                sn_type_cdesc: '类型',
                mv_cr_qty: '结算价',
                new_cr_qty: '结存',
                order_code: '订单号'
            };
            return{
                self:this,
                search:{
                    search_url: this.url,
                    datearea_id:1,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    org_cname: '',
                    cr_cat: '',
                    sn_type: ''
                },
                listHeader,//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                    sum:{}
                },
                cr_cat:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ],
                sn_type:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ]
            }
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.$base.listPageInit(this,()=>{
                this.getLoad();
            });
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            getLoad: function () {
                this.$base.showLoading();
                this.$request.sendPost("org-cr-sn/before-list",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cr_cat = this.cr_cat.concat(data.cr_cat);
                        this.sn_type = this.sn_type.concat(data.sn_type);
                        this.list()
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            list: function (change_page) {
                this.search.org_id = this.org_id;
                this.$base.list(this, change_page);
            },
            exportExcel: function(){
                // this.$base.exportExcel(this);
                excel.exportExcel(this);
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myOrgCrSn.vue